// Shared category metadata for the idea pipeline. Keep in sync with backend CATEGORIES.
import { Coffee, UtensilsCrossed, Mountain, Sparkles, ShoppingBag, Wine, Landmark, Trees, Bus, Coffee as Rest } from 'lucide-react';

export const CATEGORIES = [
    { value: 'cafe', label: 'Café', icon: Coffee, color: '#B5838D' },
    { value: 'restaurant', label: 'Restaurant', icon: UtensilsCrossed, color: '#E07A5F' },
    { value: 'viewpoint', label: 'Viewpoint', icon: Mountain, color: '#7CA5B8' },
    { value: 'activity', label: 'Activity', icon: Sparkles, color: '#D4A373' },
    { value: 'shopping', label: 'Shopping', icon: ShoppingBag, color: '#9C6644' },
    { value: 'nightlife', label: 'Nightlife', icon: Wine, color: '#6D597A' },
    { value: 'culture', label: 'Culture', icon: Landmark, color: '#1D2D44' },
    { value: 'nature', label: 'Nature', icon: Trees, color: '#4A7C59' },
];

// Itinerary activities can also be transit/rest. Kept separate from ideas' CATEGORIES so the
// idea pipeline dropdown stays clean.
export const ITINERARY_CATEGORIES = [
    ...CATEGORIES,
    { value: 'transit', label: 'Transit', icon: Bus, color: '#5C554B' },
    { value: 'rest', label: 'Rest', icon: Rest, color: '#8A8175' },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map(c => [c.value, c]));
export const ITINERARY_CATEGORY_MAP = Object.fromEntries(ITINERARY_CATEGORIES.map(c => [c.value, c]));

export const BEST_TIMES = [
    { value: 'morning', label: 'Morning' },
    { value: 'afternoon', label: 'Afternoon' },
    { value: 'evening', label: 'Evening' },
    { value: 'anytime', label: 'Anytime' },
];

export function categoryMeta(value) {
    return ITINERARY_CATEGORY_MAP[value] || CATEGORY_MAP[value] || { value, label: value, icon: Sparkles, color: '#8A8175' };
}
